/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, ContainerProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {IHitArea} from 'pixi.js';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';

export type DotButtonProps = ContainerProps & CanBeSignals<{
    onPress?: () => void;
    active?: boolean;
    hitArea: IHitArea | null;
}>;

export const $DotButton: FC<DotButtonProps> = (props) => {

    const {
        buttonName,
        scale
    } = LSViewConfig.dotButtonParams;

    return <$Button {...props}
        name={buttonName}
        hitArea={props.hitArea}
        action={props.onPress}
        disabled={!props.active}
        scale={scale}
    />;

};
